import { render, staticRenderFns } from "./MailRecipientConfig.vue?vue&type=template&id=3097652e"
import script from "./MailRecipientConfig.js?vue&type=script&lang=js&external"
export * from "./MailRecipientConfig.js?vue&type=script&lang=js&external"
import style0 from "./MailRecipientConfig.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports